import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.02535 13C7.02369 11.814 7.25679 10.6394 7.7112 9.54394C8.16561 8.44846 8.83235 7.45374 9.67299 6.61714C10.5136 5.78054 11.5115 5.1186 12.6092 4.66946C13.7069 4.22033 14.8825 3.99289 16.0685 4.00025C21.0172 4.03704 24.9756 8.15042 24.9756 13.113V14C24.9756 18.477 25.9122 21.0749 26.7372 22.4948C26.8261 22.6465 26.8734 22.819 26.8743 22.9948C26.8752 23.1706 26.8298 23.3436 26.7426 23.4962C26.6553 23.6489 26.5294 23.7759 26.3774 23.8643C26.2254 23.9527 26.0528 23.9995 25.877 24H6.12292C5.94707 23.9995 5.77445 23.9527 5.62248 23.8643C5.4705 23.7758 5.34454 23.6488 5.25731 23.4961C5.17008 23.3434 5.12465 23.1704 5.12563 22.9946C5.1266 22.8187 5.17393 22.6463 5.26284 22.4946C6.08825 21.0746 7.02534 18.4767 7.02534 14L7.02535 13Z",
      stroke: "#152443",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 24V25C12 26.0609 12.4214 27.0783 13.1716 27.8284C13.9217 28.5786 14.9391 29 16 29C17.0609 29 18.0783 28.5786 18.8284 27.8284C19.5786 27.0783 20 26.0609 20 25V24",
      stroke: "#152443",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }